module.exports = __webpack_public_path__ + "static/media/p1_4.ee2e0244.png";